import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from './Modal';

const VideoDownloader: React.FC = () => {
  const [code, setCode] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCode(e.target.value);
    setError(null);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleDownload();
    }
  };

  const handleDownload = async () => {
    if (!code) {
      setError('Il campo del codice non può essere vuoto.');
      return;
    }
    setError(null);
    setIsLoading(true);
    try {
      const checkUrl = `${API_URL}/retrive-folder/${code}`;
      const response = await fetch(checkUrl, { method: 'GET', cache: 'no-store' });
      const data = await response.json();
      if (!response.ok || !data.exists) {
        setShowModal(true);
        setIsLoading(false);
        return;
      }
      navigate(`/gallery?folder=${code}`);
    } catch (error) {
      console.error('Errore durante la verifica della cartella:', error);
      setShowModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex flex-col justify-center items-center pt-20 p-4 md:p-6">
      {/* Header alert banner */}
      <div className="absolute top-0 w-full px-4 bg-gradient-to-r from-yellow-300 to-yellow-200 text-center py-2 md:py-3 text-gray-700 font-semibold shadow-md animate-pulse">
        <span className="text-sm md:text-base">
          I file vengono trattenuti solamente per 3 giorni. Scaricali prima che scadano!
        </span>
      </div>

      <a href="https://www.instagram.com/peppe_del_don_vittorio" target="_blank" rel="noopener noreferrer">
        <img
          src="./assets/logo_donvittorio.png"
          alt="Logo"
          className="mb-6 w-64 h-64"
        />
      </a>

      <div className="bg-white bg-opacity-90 backdrop-filter backdrop-blur-sm p-8 md:p-10 rounded-2xl shadow-xl border border-gray-100 w-full max-w-md">
        <h1 className="text-2xl md:text-3xl font-bold mb-4 text-center">Inserisci il codice</h1>
        <input
          type="text"
          placeholder="Inserisci il codice"
          value={code}
          onChange={handleInputChange}
          onKeyDown={handleKeyPress}
          className="w-full px-4 py-2 border rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
          autoFocus
        />
        {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
        <button
          onClick={handleDownload}
          disabled={isLoading}
          className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold py-2 px-4 rounded shadow-md transition-all duration-300"
        >
          {isLoading ? 'Verifica in corso...' : 'Accedi alla Video Gallery'}
        </button>
      </div>

      {showModal && (
        <Modal onClose={() => setShowModal(false)}>
          <div className="text-center">
            <h2 className="text-xl font-bold mb-2">Errore</h2>
            <p>Il codice potrebbe non essere valido o i file potrebbero essere scaduti.</p>
          </div>
        </Modal>
      )}

      <footer className="mt-8 md:mt-12 w-full max-w-md mx-auto text-xs md:text-sm text-gray-600 bg-white bg-opacity-50 backdrop-filter backdrop-blur-sm py-2 md:py-3 px-4 md:px-6 rounded-full shadow-md transform transition-all hover:scale-105">
        <a
          href="https://www.instagram.com/vittorio.carcatella"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-wrap justify-center items-center gap-1 md:gap-2 hover:text-blue-600 transition-colors"
        >
          <span className="italic">
            Fatto con il <span className="inline-block mx-1 text-red-500 animate-pulse transform hover:scale-125 transition-all">❤️</span> da
          </span>
          <span className="font-bold text-blue-500 border-b border-blue-200 pb-px">Vittorio Carcatella</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 md:h-4 w-3 md:w-4 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </a>
      </footer>
    </div>
  );
};

export default VideoDownloader;